(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
function initAnnouncementBar() {
  const bars = document.querySelectorAll('.ann-bar');
  
  bars.forEach(bar => {
    if (bar.dataset.announcementInitialized === 'true') return;
    bar.dataset.announcementInitialized = 'true';

    const count = parseInt(bar.dataset.blockCount);
    if (count <= 1) return;

    const slides = bar.querySelectorAll('.ann-bar__slide');
    let current = 0;

    setInterval(() => {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }, 5000); // 5 seconds per slide
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAnnouncementBar);
} else {
  initAnnouncementBar();
}

document.addEventListener('shopify:section:load', initAnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
(function () {
  function cartSections(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = [];

    if (scope.matches && scope.matches('[data-cart-page]')) {
      sections.push(scope);
    }

    scope.querySelectorAll('[data-cart-page]').forEach(function (section) {
      sections.push(section);
    });

    return sections;
  }

  function initCartPage(root) {
    cartSections(root).forEach(function (section) {
      if (section.dataset.cartInitialized === 'true') return;
      section.dataset.cartInitialized = 'true';

      section.querySelectorAll('[data-cart-item]').forEach(function (item) {
        var input = item.querySelector('[data-qty-input]');
        var minus = item.querySelector('[data-qty-minus]');
        var plus = item.querySelector('[data-qty-plus]');

        if (minus && input) {
          minus.addEventListener('click', function () {
            input.value = Math.max(0, parseInt(input.value || '0', 10) - 1);
          });
        }

        if (plus && input) {
          plus.addEventListener('click', function () {
            input.value = parseInt(input.value || '0', 10) + 1;
          });
        }
      });

      var selectAll = section.querySelector('[data-select-all]');
      if (selectAll) {
        selectAll.addEventListener('click', function () {
          var isOn = selectAll.getAttribute('data-status') === 'on';
          section.querySelectorAll('[data-cart-check]').forEach(function (checkbox) {
            checkbox.checked = !isOn;
          });
          selectAll.setAttribute('data-status', isOn ? 'off' : 'on');
        });
      }

      var selectedDelete = section.querySelector('[data-selected-delete]');
      if (selectedDelete) {
        selectedDelete.addEventListener('click', function () {
          section.querySelectorAll('[data-cart-item]').forEach(function (item) {
            var checked = item.querySelector('[data-cart-check]');
            var quantity = item.querySelector('[data-qty-input]');
            if (checked && quantity && checked.checked) {
              quantity.value = 0;
            }
          });

          var form = selectedDelete.closest('form');
          if (form) form.submit();
        });
      }

      var selectedCheckout = section.querySelector('[data-selected-checkout]');
      if (selectedCheckout) {
        selectedCheckout.addEventListener('click', function (event) {
          var checkedItems = section.querySelectorAll('[data-cart-check]:checked');
          if (!checkedItems.length) {
            event.preventDefault();
            return;
          }

          section.querySelectorAll('[data-cart-item]').forEach(function (item) {
            var checked = item.querySelector('[data-cart-check]');
            var quantity = item.querySelector('[data-qty-input]');
            if (checked && quantity && !checked.checked) {
              quantity.value = 0;
            }
          });
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPage);
  } else {
    initCartPage();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCartPage(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
(function () {
  function collectionSections(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = [];

    if (scope.matches && scope.matches('[data-collection-section]')) {
      sections.push(scope);
    }

    scope.querySelectorAll('[data-collection-section]').forEach(function (section) {
      sections.push(section);
    });

    return sections;
  }

  function initCollectionSections(root) {
    collectionSections(root).forEach(function (section) {
      if (section.dataset.collectionInitialized === 'true') return;
      section.dataset.collectionInitialized = 'true';

      var grid = section.querySelector('.collection-grid');
      var sortButton = section.querySelector('.collection-toolbar__filter-button');
      var sortOptions = section.querySelector('.collection-toolbar__sort-options');

      section.querySelectorAll('[data-grid-count]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (!grid) return;
          var count = button.getAttribute('data-grid-count');
          grid.classList.toggle('collection-grid--4', count === '4');
          grid.classList.toggle('collection-grid--3', count !== '4');
          section.querySelectorAll('[data-grid-count]').forEach(function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      });

      if (sortButton && sortOptions) {
        sortButton.addEventListener('click', function () {
          var isOpen = sortButton.getAttribute('aria-expanded') === 'true';
          sortButton.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          sortOptions.hidden = isOpen;
        });

        document.addEventListener('click', function (event) {
          if (!section.contains(event.target)) return;
          if (event.target.closest('.collection-toolbar__sort')) return;
          sortButton.setAttribute('aria-expanded', 'false');
          sortOptions.hidden = true;
        });
      }

    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionSections);
  } else {
    initCollectionSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCollectionSections(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
function initHeader() {
  var header = document.getElementById('site-header');
  if (!header || header.dataset.headerInitialized === 'true') return;
  header.dataset.headerInitialized = 'true';

  /* ── PC Dropdown ────────────────────────────── */
  var dropdown = document.getElementById('hd-dropdown');
  var activePanel = null;

  function positionDropdown() {
    if (!dropdown || !header) return;
    dropdown.style.top = header.getBoundingClientRect().bottom + 'px';
  }

  function alignDropdown(panelId) {
    if (!dropdown) return;
    var panel = dropdown.querySelector('[data-panel="' + panelId + '"]');
    if (!panel) return;
    
    // Only apply dynamic alignment to vertical menus
    var menu = panel.querySelector('.mega-menu--vertical');
    var trigger = document.querySelector('[data-dd="' + panelId + '"]');
    if (menu && trigger) {
      var triggerRect = trigger.getBoundingClientRect();
      var panelRect = panel.getBoundingClientRect();
      var offsetLeft = triggerRect.left - panelRect.left;
      var centerOffset = offsetLeft + (triggerRect.width / 2);
      
      menu.style.margin = '0';
      menu.style.marginLeft = centerOffset + 'px';
      menu.style.transform = 'translateX(-50%)';
      menu.style.width = 'max-content';
      menu.style.justifyContent = 'flex-start';
      menu.style.alignItems = 'flex-start';
    } else {
      // Ensure multi-column menus reset to their default centered CSS behavior
      var standardMenu = panel.querySelector('.mega-menu:not(.mega-menu--vertical)');
      if (standardMenu) {
        standardMenu.style.margin = '';
        standardMenu.style.marginLeft = '';
        standardMenu.style.transform = '';
        standardMenu.style.width = '';
      }
    }
  }

  function handleResize() {
    if (activePanel) {
      positionDropdown();
      alignDropdown(activePanel);
    }
  }
  window.addEventListener('resize', handleResize);

  function openDropdown(panelId) {
    if (!dropdown) return;
    dropdown.querySelectorAll('.dd-panel').forEach(function (p) { p.classList.remove('is-active'); });
    var panel = dropdown.querySelector('[data-panel="' + panelId + '"]');
    if (!panel) return;
    panel.classList.add('is-active');
    
    alignDropdown(panelId);
    positionDropdown();
    dropdown.classList.add('is-open');
    dropdown.removeAttribute('aria-hidden');
    if (header) header.classList.add('is-dropdown-open');
    activePanel = panelId;
  }

  function closeDropdown() {
    if (!dropdown) return;
    dropdown.classList.remove('is-open');
    dropdown.setAttribute('aria-hidden', 'true');
    dropdown.querySelectorAll('.dd-panel').forEach(function (p) { p.classList.remove('is-active'); });
    document.querySelectorAll('[data-dd]').forEach(function (el) { el.setAttribute('aria-expanded', 'false'); });
    if (header) header.classList.remove('is-dropdown-open');
    activePanel = null;
  }

  document.querySelectorAll('[data-dd]').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var panelId = this.getAttribute('data-dd');
      if (activePanel === panelId) {
        closeDropdown();
      } else {
        document.querySelectorAll('[data-dd]').forEach(function (el) { el.setAttribute('aria-expanded', 'false'); });
        trigger.setAttribute('aria-expanded', 'true');
        openDropdown(panelId);
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (activePanel && !dropdown.contains(e.target) && !e.target.closest('[data-dd]')) {
      closeDropdown();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDropdown(); });

  /* ── Mobile side menu ───────────────────────── */
  var sideMenu = document.getElementById('mobile-side-menu');
  var sideOverlay = document.getElementById('side-menu-overlay');
  var mobileToggle = document.querySelector('.mobile-toggle');
  var sideClose = document.querySelector('.side-menu__close');

  function openSideMenu() {
    if (!sideMenu || !mobileToggle) return;
    sideMenu.hidden = false;
    if (sideOverlay) sideOverlay.hidden = false;
    requestAnimationFrame(function () { sideMenu.classList.add('is-open'); });
    sideMenu.removeAttribute('aria-hidden');
    mobileToggle.setAttribute('aria-expanded', 'true');
    mobileToggle.querySelector('.mobile-toggle__open').hidden = true;
    mobileToggle.querySelector('.mobile-toggle__close').hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeSideMenu() {
    if (!sideMenu || !mobileToggle) return;
    sideMenu.classList.remove('is-open');
    sideMenu.setAttribute('aria-hidden', 'true');
    mobileToggle.setAttribute('aria-expanded', 'false');
    mobileToggle.querySelector('.mobile-toggle__open').hidden = false;
    mobileToggle.querySelector('.mobile-toggle__close').hidden = true;
    document.body.style.overflow = '';
    setTimeout(function () {
      sideMenu.hidden = true;
      if (sideOverlay) sideOverlay.hidden = true;
    }, 320);
  }

  if (mobileToggle) {
    mobileToggle.addEventListener('click', function () {
      if (sideMenu.hidden) { openSideMenu(); } else { closeSideMenu(); }
    });
  }
  if (sideClose) sideClose.addEventListener('click', closeSideMenu);
  if (sideOverlay) sideOverlay.addEventListener('click', closeSideMenu);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sideMenu.hidden) closeSideMenu(); });

  /* ── Mobile sub-panels ──────────────────────── */
  document.querySelectorAll('.side-menu__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var panelId = this.getAttribute('data-panel');
      var panel = document.getElementById(panelId);
      var isOpen = this.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('.side-menu__panel').forEach(function (p) {
        p.classList.remove('is-active');
        p.hidden = true;
        p.setAttribute('aria-hidden', 'true');
      });
      document.querySelectorAll('.side-menu__trigger').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen && panel) {
        panel.classList.add('is-active');
        panel.hidden = false;
        panel.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── Scroll effect ──────────────────────────── */
  var headers = document.querySelectorAll('.site-header--transparent');
  var heroSlider = document.querySelector('.hero-slider');
  
  function handleScroll() {
    var threshold = 50;
    if (heroSlider) {
      threshold = heroSlider.offsetHeight - 50; // Trigger slightly before the end for a smoother transition
    }
    
    var scrolled = window.scrollY > threshold;
    headers.forEach(function(h) {
      if (scrolled) { h.classList.add('is-scrolled'); }
      else { h.classList.remove('is-scrolled'); }
    });
  }
  window.addEventListener('scroll', handleScroll);
  handleScroll();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeader);
} else {
  initHeader();
}

document.addEventListener('shopify:section:load', initHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-ticker"]) return;
  try {
    
function initMarqueeTicker() {
  var ticker = document.getElementById('marquee-ticker');
  if (!ticker) return;
  if (ticker.dataset.marqueeInitialized === 'true') return;
  ticker.dataset.marqueeInitialized = 'true';

  // Session storage check for dismissible state
  if (sessionStorage.getItem('heydudu_marquee_closed') === 'true') {
    document.body.classList.remove('has-marquee-ticker');
    ticker.style.display = 'none';
    return;
  }

  document.body.classList.add('has-marquee-ticker');

  var footer = document.querySelector('.footer');

  var closeBtn = ticker.querySelector('.marquee-ticker__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      ticker.style.display = 'none';
      document.body.classList.remove('has-marquee-ticker');
      if (footer) footer.style.marginTop = '0px';
      sessionStorage.setItem('heydudu_marquee_closed', 'true');
    });
  }

  // Locking state observer relative to footer
  if (footer) {
    // Move the ticker inside the footer to share its coordinate space
    footer.style.position = 'relative';
    footer.style.marginTop = '39px'; // Create physical space so it doesn't overlap previous section
    footer.appendChild(ticker);

    function updateTickerPosition() {
      var footerRect = footer.getBoundingClientRect();
      var windowHeight = window.innerHeight;
      
      // If the top of the footer is visible in the viewport
      if (footerRect.top <= windowHeight) {
        // Lock it natively to the top of the footer (no transform jitter)
        ticker.style.position = 'absolute';
        ticker.style.top = '-39px'; // Height of the ticker + 1px for footer border
        ticker.style.bottom = 'auto';
        ticker.style.transform = 'none';
      } else {
        // Floating state
        ticker.style.position = 'fixed';
        ticker.style.top = 'auto';
        ticker.style.bottom = '0px';
        ticker.style.transform = 'none';
      }
    }

    // Since we are just toggling static CSS properties, the browser handles 
    // the actual pixel movement natively, completely eliminating scroll flashing.
    window.addEventListener('scroll', updateTickerPosition, { passive: true });
    window.addEventListener('resize', updateTickerPosition, { passive: true });
    updateTickerPosition(); // Initial check
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMarqueeTicker);
} else {
  initMarqueeTicker();
}

document.addEventListener('shopify:section:load', initMarqueeTicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
(function () {
  function searchSections(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = [];

    if (scope.matches && scope.matches('[data-search-section]')) {
      sections.push(scope);
    }

    scope.querySelectorAll('[data-search-section]').forEach(function (section) {
      sections.push(section);
    });

    return sections;
  }

  function initSearchSections(root) {
    searchSections(root).forEach(function (section) {
      if (section.dataset.searchInitialized === 'true') return;
      section.dataset.searchInitialized = 'true';

      var grid = section.querySelector('.search-grid');
      var sortButton = section.querySelector('.search-toolbar__filter-button');
      var sortOptions = section.querySelector('.search-toolbar__sort-options');

      section.querySelectorAll('[data-search-grid-count]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (!grid) return;
          var count = button.getAttribute('data-search-grid-count');
          grid.classList.toggle('search-grid--4', count === '4');
          grid.classList.toggle('search-grid--3', count !== '4');
          section.querySelectorAll('[data-search-grid-count]').forEach(function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      });

      if (sortButton && sortOptions) {
        sortButton.addEventListener('click', function () {
          var isOpen = sortButton.getAttribute('aria-expanded') === 'true';
          sortButton.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          sortOptions.hidden = isOpen;
        });

        document.addEventListener('click', function (event) {
          if (!section.contains(event.target)) return;
          if (event.target.closest('.search-toolbar__sort')) return;
          sortButton.setAttribute('aria-expanded', 'false');
          sortOptions.hidden = true;
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchSections);
  } else {
    initSearchSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSearchSections(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
